import React from "react";
import { Navigate, Route } from "react-router-dom";

// Layouts
import MainLayout from "./Layouts/MainLayout";
import AuthLayout from "./Layouts/AuthLayout";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PageNotFound from "./pages/PageNotFound";

// Components
import UsersList from "./components/users/UsersList";
import UserDetails from "./components/users/UserDetails";

import CitiesList from "./components/Cities/CitiesList";

import CategoriesList from "./components/Categories/CategoriesList";
import SlidersList from "./components/Sliders/SlidersList";
import BannersList from "./components/Banners/BannersList";

import WeeklySlots from "./components/Slots/WeeklySlots";
import Holidays from "./components/Slots/Holidays";

import TestsList from "./components/Tests/TestsList";
import AddTestModal from "./components/Tests/AddTest";
import EditTestModal from "./components/Tests/EditTest";
import ViewTestModel from "./components/Tests/ViewTest";

import PackagesList from "./components/Packages/PackagesList";
import AddPackage from "./components/Packages/AddPackage";
import EditPackageModel from "./components/Packages/EditPackage";
import ViewPackage from "./components/Packages/ViewPackage";
import CouponsList from "./components/Coupons/CouponsList";
import OrdersList from "./components/Orders/OrderList";
import ViewOrder from "./components/Orders/ViewOrder";
import NotificationsList from "./components/Notifications/NotificationsList";
import PrescriptionsList from "./components/Prescriptions/PrescriptionsList";
import PermissionsList from "./components/Permissions/PermissionsList";
import RolesList from "./components/Roles/RolesList";
import SubAdminsList from "./components/SubAdmins/SubAdminsList";
import LabTechniciansList from "./components/LabTechnicians/LabTechniciansList";
import GroupingsList from "./components/Groupings/GroupingsList";
import PaymentSettings from "./components/Settings/PaymentSettings";


// 📌 Export routes as a function (we will call inside App.js)
export const appRoutes = (
  <>
    {/* Public routes */}
    <Route element={<MainLayout />}>
      <Route path="/login" element={<Login />} />
    </Route>

    {/* Protected routes */}
    <Route element={<AuthLayout />}>
      <Route path="/dashboard" element={<Dashboard />} />

      {/* Users */}
      <Route path="/users" element={<UsersList />} />
      <Route path="/user/:id" element={<UserDetails />} />
      <Route path="/user/:userId/orders/:orderId" element={<ViewOrder />} />

      {/* Cities */}
      <Route path="/cities" element={<CitiesList />} />

      {/* Categories */}
      <Route path="/categories" element={<CategoriesList />} />

      {/* Slider */}
      <Route path="/sliders" element={<SlidersList />} />

      {/* Banners */}
      <Route path="/banners" element={<BannersList />} />

      {/* Slots */}
      <Route path="/slots/weekly" element={<WeeklySlots />} />
      <Route path="/slots/holidays" element={<Holidays />} />

      {/* Tests */}
      <Route path="/tests" element={<TestsList />} />
      <Route path="/tests/add" element={<AddTestModal />} />
      <Route path="/tests/edit/:testId" element={<EditTestModal />} />
      <Route path="/tests/view/:testId" element={<ViewTestModel />} />

      {/* Packages */}
      <Route path="/packages" element={<PackagesList />} />
      <Route path="/packages/add" element={<AddPackage />} />
      <Route path="/packages/edit/:id" element={<EditPackageModel />} />
      <Route path="/packages/view/:id" element={<ViewPackage />} />

      {/* Coupons */}
      <Route path="/coupons" element={<CouponsList />} />

      {/* Grouping */}
      <Route path="/groupings" element={<GroupingsList />} />

      {/* Orders */}
      <Route path="/orders" element={<OrdersList />} />
      <Route path="/orders/view/:id" element={<ViewOrder />} />

      {/* Payment Gateway */}
      <Route path="/payment-settings" element={<PaymentSettings />} />

      {/* Notifications */}
      <Route path="/notifications" element={<NotificationsList />} />

      {/* Prescriptions */}
      <Route path="/prescriptions" element={<PrescriptionsList />} />

      {/* Access Management */}
      <Route path="/permissions" element={<PermissionsList />} />
      <Route path="/roles" element={<RolesList />} />
      <Route path="/sub-admins" element={<SubAdminsList />} />

      {/* Lab Technicians */}
      <Route path="/lab-technicians" element={<LabTechniciansList />} />

    </Route>

    {/* Page not found */}
    <Route path="/" element={<Navigate to="/dashboard" />} />
    <Route path="*" element={<PageNotFound />} />
  </>
);
